import React, { useEffect, useState } from 'react'

import { Box, Button, Divider, Text, Title } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'

interface Props {
  title: string
  subtitle?: string
  divider?: boolean
  collapsible?: boolean
  children: React.ReactNode
  defaultCollapsed?: boolean
  noGap?: boolean
}

const FormBlock = ({
  title,
  subtitle,
  divider = true,
  collapsible = false,
  defaultCollapsed = false,
  children,
  noGap = false,
}: Props) => {
  const [open, setOpen] = useState(!defaultCollapsed)

  useEffect(() => {
    setOpen(!defaultCollapsed)
  }, [defaultCollapsed])

  return (
    <Box gap={noGap ? 's0' : 's16'}>
      <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
        <Box paddingTop="s6">
          <Title variant="400" title={title} />
          {subtitle && (
            <Text.Normal size="200" color="grey800">
              {subtitle}
            </Text.Normal>
          )}
        </Box>
        {collapsible && (
          <Button
            onClick={() => setOpen(!open)}
            type="secondary"
            title="toggle"
            iconName={open ? 'chevron-up' : 'chevron-down'}
            aria-label={'form-block-toggle'}
          />
        )}
      </Box>
      <AnimatePresence>
        {(!collapsible || open) && (
          <Box.Motion
            flexDirection="column"
            gap="s16"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
          >
            {children}
          </Box.Motion>
        )}
      </AnimatePresence>
      {divider && (
        <Box paddingTop="s16" paddingBottom="s16">
          <Divider vertical={false} />
        </Box>
      )}
    </Box>
  )
}

export default FormBlock
